import React from "react";
import initSidebar from "./initSidebar";

export default class Sidebar extends React.Component {
    componentDidMount() {
       // initSidebar();
    }
    render() {
        return (
            <aside id="sidebar">
                <div className="holder">
                    <div className="post-s">{this.props.children}</div>
                </div>
            </aside>
        );
    }
}
